// Typography
export const size6 = "1rem";

export const weightNormal = 400;

export const tablet = 769;
export const desktop = 1000;
export const widescreen = 1192;
export const fullhd = 1384;

export const radius = "3px";

export const normal = size6;

export const navHeight = "3.25rem";

// controles
export const controlRadius = radius;



// WEBPACK FOOTER //
// ./bulma/size.ts